<template>
  <div class="todo-list">
    <div class="todo-list-filter">
      <v-row class="pa-4">
        <v-col cols="6" class="d-flex align-center gap-8">
          <i class="rd-file-note f-45" style="color: #a9182a"></i>
          <div>
            <section class="font-18 font-w-500">งานมอบหมาย</section>
            <section class="font-14 grey--text">
              ทั้งหมด : {{ total }} รายการ
            </section>
          </div>
        </v-col>
        <v-col cols="6" class="d-flex align-center justify-end">
          <div>
            <button
              class="btn-todo-list"
              @click="$router.push('/todo-list-form')"
            >
              <v-icon color="#fff">mdi-file-document-plus-outline</v-icon>
              <span>สร้างและแก้ไข งานมอบหมาย</span>
            </button>
          </div>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 130px"
          >
            ระยะเวลา :
          </section>
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dateFormat"
                placeholder="เริ่มต้น-สิ้นสุด"
                append-icon="rd-calendar-days"
                color="#a9182a"
                outlined
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="clearDate()"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              color="#aa0c1e"
              range
              no-title
              @change="changeDate()"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 130px"
          >
            ประเภทงาน :
          </section>
          <v-select
            v-model="taskTypeId"
            :items="taskTypeList"
            item-text="name"
            item-value="id"
            placeholder="ทั้งหมด"
            append-icon="mdi-chevron-down"
            color="#a9182a"
            outlined
            hide-details
            dense
            clearable
            @change="changeFilter()"
          ></v-select>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 130px"
          >
            สถานะงาน :
          </section>
          <v-select
            v-model="statusId"
            :items="statusList"
            item-text="name"
            item-value="id"
            placeholder="ทั้งหมด"
            append-icon="mdi-chevron-down"
            color="#a9182a"
            outlined
            hide-details
            dense
            clearable
            @change="changeFilter()"
          ></v-select>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 130px"
          >
            ผู้สร้างงาน :
          </section>
          <v-select
            v-model="userCreateTaskId"
            :items="userCreateTaskList"
            item-text="user_name"
            item-value="planby_user_id"
            placeholder="ทั้งหมด"
            append-icon="mdi-chevron-down"
            color="#a9182a"
            outlined
            hide-details
            dense
            clearable
            @change="changeFilter()"
          ></v-select>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 130px"
          >
            ประเภทการสร้าง :
          </section>
          <v-select
            v-model="createTypeId"
            :items="createTypeList"
            item-text="name"
            item-value="id"
            placeholder="ทั้งหมด"
            append-icon="mdi-chevron-down"
            color="#a9182a"
            outlined
            hide-details
            dense
            clearable
            @change="changeFilter()"
          ></v-select>
        </v-col>
        <v-col cols="12" style="position: relative">
          <input
            v-model="search"
            class="input-search"
            type="text"
            placeholder="ค้นหาชื่องาน"
            @keypress.enter="changeFilter()"
          />
          <button class="input-search--btn" @click="changeFilter()">
            <v-icon color="#fff">mdi-magnify</v-icon>
          </button>
        </v-col>
      </v-row>
    </div>

    <div class="todo-list-main">
      <div class="d-flex align-center gap-8 mt-2 mb-4">
        <v-icon color="#a9182a">mdi-format-list-bulleted-square</v-icon>
        <span class="font-18 font-w-500 font-red">รายการ งานมอบหมาย</span>
      </div>

      <div
        v-if="todoList.length === 0"
        class="d-flex align-center justify-center pa-10"
      >
        <span>ไม่พบข้อมูล</span>
      </div>

      <div v-else class="d-flex justify-center">
        <div class="todo-list-table">
          <div class="todo-list-table--header">
            <section style="flex-basis: 100px">
              <span>#</span>
            </section>
            <section style="flex-basis: 150px">
              <div>
                <span>ชื่อร้านค้าช่วง</span>
                <br />
                <span>BPNO</span>
              </div>
            </section>
            <section style="flex-basis: 150px">
              <span>จังหวัด/อำเภอ</span>
            </section>
            <section style="flex-basis: 150px">
              <span>รายละเอียดงาน</span>
            </section>
            <section style="flex-basis: 150px">
              <span>ประเภทงาน</span>
            </section>
            <section style="flex-basis: 150px">
              <span>กำหนดเสร็จ</span>
            </section>
            <section style="flex-basis: 150px">
              <span>ประเภทการสร้าง</span>
            </section>
            <section style="flex-basis: 150px">
              <span>Status</span>
            </section>
            <section style="flex-basis: 100px">
              <span>Preview</span>
            </section>
          </div>

          <div
            v-for="(item, index) in todoList"
            :key="item.todolist_id"
            class="todo-list-table--body"
            :style="{ background: index % 2 === 0 ? '#fff' : '#F8F8F8' }"
          >
            <section
              title="#"
              style="flex-basis: 100px"
              class="d-flex align-center justify-center"
            >
              <TodoListFormDialog
                v-if="item.status_txt === 'ยังไม่ได้ทำ'"
                mode="create"
                :data="item"
                @closeDialog="getTodoList()"
              >
                <template #activate="{ openDialog }">
                  <div class="checkbox--empty" @click="openDialog"></div>
                </template>
              </TodoListFormDialog>
              <div v-if="item.status_txt === 'ทำแล้ว'" class="checkbox--check">
                <v-icon color="#fff">mdi-check</v-icon>
              </div>
              <div
                v-if="item.status_txt === 'ไม่ได้ทำ'"
                class="checkbox--close"
              >
                <v-icon color="#fff">mdi-close</v-icon>
              </div>
            </section>
            <section
              title="ชื่อร้านค้าช่วง"
              style="flex-basis: 150px"
              class="d-flex align-center"
            >
              <div class="px-2">
                <span class="line-clamp-1">{{
                  item.customer_name || '-'
                }}</span>
                <span>{{ item.ScgBPNumber || '-' }}</span>
              </div>
            </section>
            <section
              title="จังหวัด/อำเภอ"
              style="flex-basis: 150px"
              class="d-flex align-center"
            >
              <div class="px-2">
                <span>{{ item.PROVINCE_NAME || '-' }} /</span>
                <br />
                <span>{{ item.AMPHUR_NAME || '-' }}</span>
              </div>
            </section>
            <section
              title="รายละเอียดงาน"
              style="flex-basis: 150px"
              class="d-flex align-center"
            >
              <div class="pa-2">
                <span>
                  {{ item.detail || '-' }}
                </span>
              </div>
            </section>
            <section
              title="ประเภทงาน"
              style="flex-basis: 150px"
              class="d-flex align-center justify-center flex-column"
            >
              <span>{{ item.task_type_name || '-' }}</span>
              <div v-if="item.winloss === '1'" class="task-type--win">Win</div>
              <div v-if="item.winloss === '2'" class="task-type--loss">
                Loss
              </div>
              <div v-if="item.winloss === '3'" class="task-type--follow-up">
                ติดตามต่อ
              </div>
            </section>
            <section
              title="กำหนดเสร็จ"
              style="flex-basis: 150px"
              class="d-flex align-center justify-center"
            >
              <span>{{ item.due_date || '-' }}</span>
            </section>
            <section
              title="ประเภทการสร้าง"
              style="flex-basis: 150px"
              class="d-flex align-center justify-center"
            >
              <span>{{ item.plan_by_txt || '-' }}</span>
            </section>
            <section
              title="Status"
              style="flex-basis: 150px"
              class="d-flex align-center justify-center"
            >
              <div
                v-if="item.status_txt === 'ยังไม่ได้ทำ'"
                class="status-box--yellow"
              >
                ยังไม่ได้ทำ
              </div>
              <div
                v-if="item.status_txt === 'ทำแล้ว'"
                class="status-box--green"
              >
                ทำแล้ว
              </div>
              <div
                v-if="item.status_txt === 'ไม่ได้ทำ'"
                class="status-box--red"
              >
                ไม่ได้ทำ
              </div>
            </section>

            <section
              title="Preview"
              style="flex-basis: 100px"
              class="d-flex align-center justify-center"
            >
              <div
                v-if="item.status_txt === 'ยังไม่ได้ทำ'"
                class="preview-icon--disabled"
              >
                <v-icon color="#BFBFBF">mdi-eye</v-icon>
              </div>
              <TodoListFormDialog
                v-else
                mode="show"
                :data="item"
                @cancelTask="getTodoList"
              >
                <template #activate="{ openDialog }">
                  <div class="preview-icon" @click="openDialog">
                    <v-icon color="#0068C9">mdi-eye</v-icon>
                  </div>
                </template>
              </TodoListFormDialog>
            </section>
          </div>
        </div>
      </div>

      <div class="my-5">
        <v-pagination
          v-model="page"
          :length="pageTotal"
          color="#a9182a"
          circle
          @input="getTodoList"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

import TodoListFormDialog from '@/components/v2/todoList/TodoListFormDialog.vue'

export default {
  components: {
    TodoListFormDialog,
  },

  data() {
    return {
      dateMenu: false,
      date: [],
      taskTypeId: '',
      taskTypeList: [],
      statusId: '',
      statusList: [
        {
          id: 0,
          name: 'ยังไม่ได้ทำ',
        },
        {
          id: 1,
          name: 'ทำแล้ว',
        },
        {
          id: 2,
          name: 'ไม่ได้ทำ',
        },
      ],
      userCreateTaskId: '',
      userCreateTaskList: [],
      createTypeId: '',
      createTypeList: [
        {
          id: 1,
          name: 'SCG',
        },
        {
          id: 2,
          name: 'OSR',
        },
      ],
      search: '',
      page: 1,
      pageTotal: 0,
      limit: 10,
      total: 0,
      todoList: [],
    }
  },
  computed: {
    dateFormat() {
      if (this.date.length === 2) {
        const startDate = dayjs(this.date[0]).format('DD/MM/YYYY')
        const endDate = dayjs(this.date[1]).format('DD/MM/YYYY')
        return `${startDate} - ${endDate}`
      }
      return ''
    },
  },
  mounted() {
    this.$store.dispatch('setTitle', 'งานมอบหมาย')
    this.getTaskType()
    this.getUserCreateTask()
    this.getTodoList()
  },
  methods: {
    changeDate() {
      this.date.sort((a, b) => new Date(a) - new Date(b))
      this.changeFilter()
    },
    clearDate() {
      this.date = []
      this.changeFilter()
    },
    async getUserCreateTask() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/userCreateTask`,
          {},
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.userCreateTaskList = res.data.items
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getTaskType() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/getTasktype`,
          {},
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.taskTypeList = res.data.items
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getTaskType() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/getTasktype`,
          {},
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.taskTypeList = res.data.items
        }
      } catch (error) {
        console.error(error)
      }
    },
    changeFilter() {
      this.page = 1
      this.getTodoList()
    },
    async getTodoList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/todolist/getTaskTodolist_OSR`,
          {
            provinces: '',
            start_date: this.date.length === 2 ? this.date[0] : '',
            end_date: this.date.length === 2 ? this.date[1] : '',
            task_type: this.taskTypeId,
            status: this.statusId,
            planby_user_id: this.userCreateTaskId,
            plan_by: this.createTypeId,
            search: this.search,
            page: this.page,
            limit: this.limit,
          },
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.todoList = res.data.items.list
          this.pageTotal = res.data.items.page.total
          this.total = res.data.items.page.total_row
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.todo-list {
  padding-top: 4rem;
  background: #e4e7ec;
  min-height: 100dvh;
}
.todo-list-filter {
  background: #fff;
  border-radius: 0px 0px 20px 20px;
}
.btn-todo-list {
  border-radius: 6px;
  background: #a9182a;
  color: #fff;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}
.input-search {
  border-radius: 8px;
  padding: 0.5rem;
  border: 1px solid #d2d2d2;
  background: #fff;
  width: 100%;
  height: 40px;

  &--btn {
    position: absolute;
    right: 0;
    width: 40px;
    height: 40px;
    background: #a9182a;
    border-radius: 0px 8px 8px 0px;
  }
}

.todo-list-main {
  background: #fff;
  border-radius: 20px;
  margin: 1rem;
  padding: 1rem;
}

.todo-list-table {
  overflow-x: auto;
  border-radius: 8px;

  &--header {
    display: flex;
    width: 1250px;
    background: #000;
    color: #fff;
    font-size: 14px;

    & section {
      height: 52px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    & section:not(:last-child) {
      border-right: 1px solid #484848;
    }
  }
  &--body {
    display: flex;
    width: 1250px;
    font-size: 14px;

    & section {
      min-height: 70px;
      flex-shrink: 0;
    }
  }
}

.checkbox {
  border-radius: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &--empty {
    @extend .checkbox;
    border: 1px solid #4a90e2;
    background: #fff;
  }
  &--check {
    @extend .checkbox;
    border: 1px solid #4a90e2;
    background: #4a90e2;
  }
  &--close {
    @extend .checkbox;
    border: 1px solid #a9182a;
    background: #a9182a;
  }
}

.status-box {
  border-radius: 8px;
  color: #fff;
  padding: 0.5rem 1rem;
  &--green {
    @extend .status-box;
    background: #259b12;
  }
  &--yellow {
    @extend .status-box;
    background: #eab500;
  }
  &--red {
    background: #a50200;
    @extend .status-box;
  }
}

.preview-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid #b5cee6;
  background: #e3f5ff;

  &--disabled {
    @extend .preview-icon;
    border: 1px solid #e0e0e0;
    background: #f3f3f3;
  }
}

.task-type {
  border-radius: 4px;
  padding: 2px 12px;
  font-size: 14px;
  font-weight: 500;
  &--win {
    @extend .task-type;
    background: #edf8ec;
    color: #259b12;
  }
  &--loss {
    @extend .task-type;
    background: #feeced;
    color: #ff5252;
  }
  &--follow-up {
    @extend .task-type;
    background: #ecf0fe;
    color: #5272ff;
  }
}
</style>
